module.exports = __webpack_public_path__ + "static/media/DNPDP.ada49bfa.pdf";